import { setLocal, getLocal } from '@/common/js/api'

export default {
  data () {
    return {
      pageIndex: 1,
      pageSize: parseInt(getLocal('PAGESIZE')) || 20,
      total: 0,
      modalColumn: false // 自定义列
    }
  },
  methods: {
    changePageIndex (index) {
      this.pageIndex = index
      this.getData()
    },
    changePageSize (size) {
      this.setLocalPage(size) // 设置常用页码
      this.pageSize = size
      if (this.pageIndex === 1) this.getData()
    },
    setLocalPage (size) {
      setLocal('PAGESIZE', size)
    },
    filterData (params) {
      this.pageIndex = 1
      this.getData(params)
    }
  }
}
